import { useContext, useEffect, useState } from 'react'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import menuOpcoes from '../../interfaces/propsMenuOpcoes'
import { listarTarefas } from '../../services/tasks'
import '../../styles/menuopcoes.css'
import SubMenuOpcoes from '../SubMenuOpcoes'
import Permissoes from '../../middleware/Permissoes'

function MenuTarefas (props: menuOpcoes) {

    const { atualizarInformacoes } = useContext(ModalEstadoContext)

    const [subMenu, setSubMenu] = useState(false)
    const [minhasTarefas, setMinhasTarefas] = useState(0)
    const [minhasSolicitacoes, setMinhasSolicitacoes] = useState(0)
    const [aguardandoAprovarTarefas, setAguardandoAprovarTarefas] = useState(0);

    const data = new Date()

    const ano = data.getFullYear()
    const qtnDias = new Date (data.getFullYear(), data.getMonth() + 1, 0).getDate()
    const dataAnterior = new Date (new Date().setDate(new Date().getDate() - 60))
    
    const dataInicial = `${dataAnterior.getFullYear()}-${(dataAnterior.getMonth() + 1).toString().padStart(2, '0')}-01`
    const dataFinal = `${ano}-${(data.getMonth() + 1).toString().padStart(2, '0')}-${qtnDias}`

    const usuarioLogado = localStorage.getItem('usuarioGesttor')

    function exibirSubmenu () {
        setSubMenu (subMenu => !subMenu)
    }

    useEffect(() => {
        const buscarTarefas = async () => {
            const paramsList = [
                {
                    pagina: 1,
                    titulo: '',
                    descricao: '',
                    cliente: '',
                    responsavel: '',
                    situacao: 'pendente',
                    minhasSolicitacoes: false,
                    tarefasEscritorio: false,
                    tarefasAutomaticas: false,
                    dataInicio: dataInicial,
                    dataTermino: dataFinal,
                },
                {
                    pagina: 1,
                    titulo: '',
                    descricao: '',
                    cliente: '',
                    responsavel: '',
                    situacao: 'pendente',
                    minhasSolicitacoes: true,
                    tarefasEscritorio: false,
                    tarefasAutomaticas: false,
                    dataInicio: dataInicial,
                    dataTermino: dataFinal,
                },
                {
                    pagina: 1,
                    titulo: '',
                    descricao: '',
                    cliente: '',
                    responsavel: usuarioLogado,
                    idUsuarioAprovador: usuarioLogado,
                    situacao: 'pendente',
                    minhasSolicitacoes: false,
                    tarefasEscritorio: false,
                    tarefasAutomaticas: false,
                    dataInicio: dataInicial,
                    dataTermino: dataFinal,
                }
            ];

            try {
                const [minhasTarefasRes, minhasSolicitacoesRes, aguardandoAprovarRes] =
                    await Promise.all(paramsList.map(params => listarTarefas(params)));

                if (minhasTarefasRes.status === 200) setMinhasTarefas(minhasTarefasRes.data.length);
                if (minhasSolicitacoesRes.status === 200) setMinhasSolicitacoes(minhasSolicitacoesRes.data.length);
                if (aguardandoAprovarRes.status === 200) setAguardandoAprovarTarefas(aguardandoAprovarRes.data.length);

            } catch (error) {
                console.error('Erro ao buscar tarefas:', error);
            }
        };

        buscarTarefas();
    }, [dataInicial, dataFinal, atualizarInformacoes, usuarioLogado]);

    return (
        <div>
            <div id = 'menuOpcoes' onClick={exibirSubmenu}>
                {<img id = 'iconeMenu' src= {props.icone} alt = {props.alt}></img>}
                <p id = 'tituloMenu'>{props.titulo}</p>
                {(minhasTarefas + minhasTarefas) !== 0 ? <h2>{minhasTarefas + minhasSolicitacoes}</h2> : null}
            </div>
            <div id = 'submenuOpcoes'>
                {subMenu && <SubMenuOpcoes redirect = {'/tarefas'} texto = 'Minhas Tarefas' notificacao={minhasTarefas === 0 ? null : minhasTarefas}/>}
                {subMenu && <SubMenuOpcoes redirect = {'/tarefas?minhasSolicitacoes=true'} texto = 'Minhas Solicitações' notificacao={minhasSolicitacoes === 0 ? null : minhasSolicitacoes}/>}
                {subMenu && <SubMenuOpcoes redirect = {'/tarefas?solicitacaoAprovacao=true'} texto = 'Aprovar Tarefas' notificacao={aguardandoAprovarTarefas === 0 ? null : aguardandoAprovarTarefas}/>}
                <Permissoes permissoes={['master', 'administrativo', 'tarefas_recorrentes']}>
                    {subMenu && <SubMenuOpcoes redirect = {'/tarefas?automaticas=true'} texto = 'Tarefas Recorrentes'/>}
                </Permissoes>
                <Permissoes permissoes={['master', 'tarefas_visao_geral']}>
                        {subMenu && <SubMenuOpcoes redirect = '/tarefas?escritorio=true' texto = 'Visão Geral'/>}
                </Permissoes>
            </div>
        </div>
    )
}

export default MenuTarefas